import { render, staticRenderFns } from "./InputStar.vue?vue&type=template&id=b32af2b2&scoped=true&lang=html"
import script from "./InputStar.vue?vue&type=script&lang=js"
export * from "./InputStar.vue?vue&type=script&lang=js"
import style0 from "./InputStar.vue?vue&type=style&index=0&id=b32af2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32af2b2",
  null
  
)

export default component.exports